import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

// import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/sass/style.scss';

import Home from './pages/Home/Home'
const Pay = lazy(() => import('./pages/Pay'))
const Price = lazy(() => import('./pages/Price'))
const UserFlow = lazy(() => import('./pages/UserFlow'))


function App() {
  return (
    <Suspense>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/pay' element={<Pay />} />
        <Route path='/pricing' element={<Price />} />
        <Route path='/user-flow' element={<UserFlow />} />
      </Routes>
    </Suspense>
  );
}

export default App;
